import {
  compose,
  withPropsOnChange,
  mapProps,
  branch,
  lifecycle,
  setPropTypes,
  createSink,
  withProps,
} from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getUserHeaderInfo } from '../Common/Providers/UserHeaderInfoApi';
import { connectUserDetail } from './UserDetailManager';
import { hasTokenManager, isLoggedIn as maybeIsLoggedIn } from './TokenManager';
import { isObjectEmpty } from '../Common/Helper';
import { type } from '../Reducer';
import { withDataLayerCustomerTypePush } from "../Common/GTM/WithDataLayerCustomerType";
import { withFetchOnMount } from '../Common/Spinner';
import { withDataLayerPush } from '../Common/GTM/withDataLayerPush';

const mapUserHeaderInfoStateToProps = ({ userHeaderInfo = {} }) => ({ userHeaderInfo });
export const mapUserHeaderInfoDispatchToProps = dispatch => ({
  setUserHeaderInfo: payload => dispatch({
    type: type.userHeaderInfo,
    payload: {
      userHeaderInfo: payload,
    }
  }),
});

export const connectUserHeaderinfo = (WrappedComponent) => {
  return connect(mapUserHeaderInfoStateToProps, mapUserHeaderInfoDispatchToProps)(WrappedComponent);
};

const test = ({ shouldRemoveAllTokens }) => shouldRemoveAllTokens;

export const withFetchUserHeaderInfoOnMount = WrappedComponent => compose(
  withFetchOnMount(getUserHeaderInfo),
  lifecycle({
    componentWillReceiveProps() {
      getUserHeaderInfo()
        .then(data => this.setState({ data }));
    },
  }),
  mapProps(({ loading, data: { data = {} } = {}, ...keys }) => ({
    userHeaderInfo: data,
    ...keys,
  })),
)(WrappedComponent);

const propTypes = {
  userHeaderInfo: PropTypes.object.isRequired,
};

export const withUserHeaderInfo = compose(
  withPropsOnChange(['userHeaderInfo'], (props) => {
    const {
      userHeaderInfo: {
        isLoggedIn = maybeIsLoggedIn(),
      } = {},
      userDetail = null,
    } = props;

    return {
      shouldRemoveAllTokens: (!userDetail || isObjectEmpty(userDetail) || !isLoggedIn),
    };
  }),
  branch(
    test,
    lifecycle({
      componentWillMount() {
        this.props.removeUserDetail();
        this.props.setToken(null);
      },
    }),
  ),
);

const isUserNewCustomer = ({ userHeaderInfo: { isNewCustomer = true } }) => isNewCustomer;
const checkCustomerType = compose(
  branch(
    isUserNewCustomer,
    withProps(({ dataLayerCustomerTypePush }) => (dataLayerCustomerTypePush({ customerType: 'new' }))),
    withProps(({ dataLayerCustomerTypePush }) => (dataLayerCustomerTypePush({ customerType: 'returned' }))),
  ));

const withDataLayerEmarsysCart = compose(
  withDataLayerPush,
  withProps(({ dataLayerPush, userHeaderInfo }) => (dataLayerPush({ emarsysCartItems: userHeaderInfo.cartItems })))
);

export const callback = ({
  userHeaderInfo,
  setUserHeaderInfo,
}) => {
  setUserHeaderInfo(userHeaderInfo);
};

const enhance = compose(
  hasTokenManager,
  connectUserDetail,
  connect(null, mapUserHeaderInfoDispatchToProps),
  withFetchUserHeaderInfoOnMount,
  withUserHeaderInfo,
  withDataLayerCustomerTypePush,
  branch(
    maybeIsLoggedIn,
    checkCustomerType,
  ),
  setPropTypes(propTypes),
  withDataLayerEmarsysCart
);

export default enhance(createSink(callback));



// WEBPACK FOOTER //
// ./src/Auth/WithUserHeaderInfo.js